import { useMutation } from '@vue/apollo-composable';
import {
  CLOSE_STUDENT_DATA_REQUEST, CREATE_STUDENT_DATA_REQUEST, REMIND_STUDENT_DATA_REQUEST,
  REOPEN_STUDENT_DATA_REQUEST, UPDATE_STUDENT_DATA_REQUEST,
} from '@/graphql/studentDataRequests';
import type {
  CloseStudentDataRequestMutation, CloseStudentDataRequestMutationVariables,
  CreateStudentDataRequestMutation, CreateStudentDataRequestMutationVariables,
  RemindStudentDataRequestMutation, RemindStudentDataRequestMutationVariables,
  ReopenStudentDataRequestMutation, ReopenStudentDataRequestMutationVariables,
  UpdateStudentDataRequestMutation, UpdateStudentDataRequestMutationVariables,
} from '@/types/operations';

/**
 * Sending and managing data requests. Each answer is a full request with its
 * id, so Apollo updates it in place; the lists are refetched where a change
 * moves a request between them (sent, closed, reopened) and the recipients
 * after a reminder.
 */
export function useStudentDataRequestMutations() {
  const create = useMutation<CreateStudentDataRequestMutation, CreateStudentDataRequestMutationVariables>(
    CREATE_STUDENT_DATA_REQUEST,
    { refetchQueries: ['StudentDataRequests'] },
  );
  const update = useMutation<UpdateStudentDataRequestMutation, UpdateStudentDataRequestMutationVariables>(
    UPDATE_STUDENT_DATA_REQUEST,
  );
  const close = useMutation<CloseStudentDataRequestMutation, CloseStudentDataRequestMutationVariables>(
    CLOSE_STUDENT_DATA_REQUEST,
    { refetchQueries: ['StudentDataRequests'] },
  );
  const reopen = useMutation<ReopenStudentDataRequestMutation, ReopenStudentDataRequestMutationVariables>(
    REOPEN_STUDENT_DATA_REQUEST,
    { refetchQueries: ['StudentDataRequests'] },
  );
  const remind = useMutation<RemindStudentDataRequestMutation, RemindStudentDataRequestMutationVariables>(
    REMIND_STUDENT_DATA_REQUEST,
    { refetchQueries: ['StudentDataRequestRecipients'] },
  );

  return { create, update, close, reopen, remind };
}
